import React from "react";
import { Dot, Label, Pill } from "./KgFilterPill.styles";
import type { KgFilterPillProps } from "./KgFilterPill.types";

export const KgFilterPill: React.FC<KgFilterPillProps> = ({
  label,
  isSelected,
  dotColor,
  disabled = false,
  onClick,
}) => (
  <Pill
    $isSelected={isSelected}
    $disabled={disabled}
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    {dotColor && <Dot $color={dotColor} $isSelected={isSelected} />}
    <Label $isSelected={isSelected} $disabled={disabled}>
      {label}
    </Label>
  </Pill>
);

export default KgFilterPill;
